const InvestmentInformationText =[
       {investType: "stock", imageURL: "stocks.jpg",
              text: "A stock is a small piece of a company that you can own. " +
              "When you buy a stock, you become a part-owner of that company. " +
              "If the company does well, your stock can go up in value and you  " +
              "earn money. But if the company does poorly, you can lose money too."},
       {investType: "bond", imageURL: "bonds.jpg",
              text: "A bond is like a loan you give to a company or the government. " +
              "In return, they promise to pay you back later with extra money " +
              "called interest. Bonds are usually safer than stocks, but they often " +
              "grow more slowly."},
       {investType: "index", imageURL: "indexFunds.jpg",
              text:  "A type of investment that holds small pieces of many different companies’ " +
                     "stocks, designed to match how a whole market (like the S&P 500) is doing. " +
                     "It’s a simple way to invest in lots of companies at once."},
       {investType: "mutualfund", imageURL: "mutualFunds.jpg",
              text:  "A mutual fund is a big pool of money collected from many people. " +
                     "A professional manager uses that money to buy a mix of investments, " +
                     "like stocks and bonds. This helps spread out risk and makes it easier " +
                     "for people to invest without picking everything themselves."
       }
]
    
export default InvestmentInformationText;